export interface LinkAccountForm {
  identificator: string;
}

export enum ProfileLinkedAccountStatus {
  acceptedOld = 1, // blue
  Pending = 2, // orange
  Accepted = 3, // green
  rejectedOld = 4, // red
}
